/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Cat_Canceled_HintInputs */

const en_sch_cat_canceled_hint = /** @type {(inputs: Sch_Cat_Canceled_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed without finishing.`)
};

const de_sch_cat_canceled_hint = /** @type {(inputs: Sch_Cat_Canceled_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Abschluss geschlossen.`)
};

/**
* | output |
* | --- |
* | "Closed without finishing." |
*
* @param {Sch_Cat_Canceled_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_cat_canceled_hint = /** @type {((inputs?: Sch_Cat_Canceled_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Cat_Canceled_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_cat_canceled_hint(inputs)
	return en_sch_cat_canceled_hint(inputs)
});